import { LoadingView } from '../../components/LoadingView'
// api
import { useGetObjectsChildren } from '../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { AutomationObjectsFlexGridView } from './Grid/AutomationObjectsFlexGridView';

type ChildrenViewProps = {
    parentId: string,
     resourceGroupId: string, 
     filter?: (app: any) => boolean | undefined,
     sort?: (a: any, b: any) => number,
}

export function ChildrenView({ parentId, resourceGroupId, filter, sort } : ChildrenViewProps) {
    const { children, error, isLoading, isSuccess } = useGetObjectsChildren(resourceGroupId, parentId);
    const filterdItems = useMemo(() => {
        const filtered = filter ? children?.filter((a) => filter(a)) : children;
        const sorted = sort ? filtered?.sort(sort) : filtered;
        return sorted;
    }, [children, filter])
    
    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <AutomationObjectsFlexGridView  noSort={sort !== undefined} items={filterdItems ?? []}></AutomationObjectsFlexGridView>
        </LoadingView>
    )
}

 